import Icon from "@mdi/react";
import { mdiPlus } from "@mdi/js";
import { useLang } from "../../../services/lang";
import { ArrowDown } from "../../../components";
import { V } from "../../../components/Vote";
import { TeamEventDetail } from "./TeamEventDetail";
import { ID, TeamEvent, Team } from "../../../../types";
import { getUserPermissions } from "../utils";

type ShowEventsProps = {
    teamId: ID;
    isActive: boolean;
    userHashId: string;
    users: Team["users"];
    events: (TeamEvent & { date: string })[];
    onEditEvent: (date?: string) => void;
    onChange: () => void;
};

export function ShowEvents(props: ShowEventsProps) {
    const { dict } = useLang();
    const { isActive, events, onEditEvent } = props;
    const { isTeamAdmin, isTeamMember } = getUserPermissions(props.userHashId, props.users);

    return <>
        {events.length === 0 && <p className="info">{dict.teamEventEmpty}</p>}
        {isActive && isTeamAdmin && <a className="button-new" onClick={() => onEditEvent()}>
            <Icon path={mdiPlus} size={1} /> {dict.teamEventAdd}
        </a>}

        {events.length > 0 && <>
            {isActive && <>
                {!isTeamMember && <p className="info">{dict.teamMemberRequired}</p>}
                {isTeamMember && <div className="vote-legend width-max">
                    <div>
                        <V yes />
                        {dict.whenLegendYes}
                        <ArrowDown height={121} />
                    </div>
                    <div>
                        <V maybe />
                        {dict.whenLegendMaybe}
                        <ArrowDown height={86} />
                    </div>
                    <div>
                        <V no />
                        {dict.whenLegendNo}
                        <ArrowDown height={51} />
                    </div>
                    <div className="legend-comment">
                        {dict.teamEventDetail}
                        <ArrowDown height={16} />
                    </div>
                </div>}
            </>}
            <ul className="poll-options when-options">
                {events.map((event, index) => <TeamEventDetail
                    key={index}
                    {...props}
                    isActive={isActive && isTeamMember}
                    event={event}
                />)}
            </ul>
        </>}
    </>;
}
